import React, { useEffect, useState } from "react";
import { Image, Flex, Text } from "@chakra-ui/react";
import moment from "moment/moment";

import BottomNavbar from "../components/Navbars/BottomNavbar.jsx";
import UserInformation from "../components/LobbyMenu/UserInformation.jsx";
import ServiceList from "../components/LobbyMenu/ServiceList.jsx";
import Upcoming from "../components/carousels/Upcoming.jsx";
import Contact from "../components/CTA/Contact.jsx";
import BannerHomepage from "../assets/img/banner-homepage.png";
import MascotFooter from "../assets/img/mascot-footer.png";
import Axios from "../utils/axiosService.js";

function Index() {
  moment.locale();
  const [userDetail, setUserDetail] = useState("");

  localStorage.removeItem("bookingFormFilterData");

  const logoutHandler = () => {
    localStorage.removeItem("login");
    localStorage.removeItem("region_user");
    localStorage.removeItem("role_user");
    localStorage.removeItem("username");
    localStorage.removeItem("id_user");
    localStorage.removeItem("paraspaceToken");
    localStorage.removeItem("user_data");
    window.location.assign("/auth/login");
  };

  useEffect(() => {
    let userData = JSON.parse(localStorage.getItem("user_data"));

    Axios({
      method: "GET",
      url: `/user?user_name=${userData?.user_name}${
        userData?.user_email && `&user_email=${userData?.user_email}`
      }`,
    })
      .then((result) => {
        if (result.status === 200) {
          setUserDetail(result.data.data.data[0]);
        }
      })
      .catch(() => {
        logoutHandler();
      });
  }, []);

  return (
    <Flex direction="column" paddingBottom="340px">
      <Flex
        gap="24px"
        alignItems="center"
        color="rgba(0, 0, 0, 0.8)"
        bgColor="#EBF3FF"
        padding="24px 16px 16px"
        direction="column"
      >
        <Image
          width="100%"
          backgroundPosition="center center"
          backgroundRepeat="no-repeat"
          alt="Homepage"
          src={BannerHomepage}
        />
      </Flex>

      <UserInformation userName={userDetail.user_name} />

      <Flex width="100%" direction="column" rowGap="24px" marginTop="24px">
        <ServiceList userDetail={userDetail} />
        <Upcoming />
        <Contact />
      </Flex>

      <Flex
        position="absolute"
        bottom="0px"
        width="100%"
        gap="24px"
        alignItems="center"
        color="#222222"
        bgColor="#EBF3FF"
        padding="32px 16px 102px 16px"
        direction="column"
      >
        <Image
          width="125px"
          backgroundPosition="center center"
          backgroundRepeat="no-repeat"
          alt="Homepage"
          src={MascotFooter}
        />
        <Flex direction="column" rowGap="4px" alignItems="center">
          <Text fontSize="12px" fontWeight="400">
            Paraspace
          </Text>
          <Text fontSize="12px" fontWeight="400">
            © PT Paragon Technology and Innovation
          </Text>
        </Flex>
      </Flex>

      <BottomNavbar />
    </Flex>
  );
}

export default Index;
